export const en = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>
                Film Directed by <strong>Mohammad Gorjestani</strong>, Photography by <strong>Ike Edeani</strong>
            </p>`
    },
    {
      template: 'leadModule',
      body: `“I’m raising my children to know their American side and their Muslim side. They learn their religion, they play soccer, they love boxing. There’s no difference between them and other kids.”`
    },
    {
      template: 'textModule',
      text: `<p>
                Like any single mother in America, Zahraa’s day-to-day schedule is something of a manic ballet. She is raising three healthy young boys, including one set of twins, all under age ten. She is also a Muslim, and she has found that many people assume her religious identity makes her experience somehow different from that of a non-Muslim single mom. 
            </p>
            <p>
                It isn’t. “I wake up early every morning, and at the same time I’m leaving, my neighbor's leaving—and we’re both taking our kids to school, taking them to appointments, running the exact same errands at the exact same time,” she says. (She makes it a point to have girls’ nights with her friends, too—when she can make the time.)
            </p>
            <p>
                Zahraa was born in California to Lebanese parents. She’s an American, wears a headscarf, and speaks without an  accent. She works at a car dealership when she’s not driving for Lyft. As the first point of contact for many customers over the phone, she explains,“they don’t know what I look like. And so they come into the dealership and they see a Muslim woman wearing a scarf. It either surprises them in a good way or it surprises them in a bad way.”
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-zahraa/zahraa-image-gallery1-1.jpg',
          alt: 'Zahraa on the phone while at work at a car dealership',
          index: '01',
          caption: `<p>Zahraa takes a call at the car dealership where she works. "On the phone, I sound American, you know?"</p>`
        },
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-zahraa/zahraa-image-gallery1-2.jpg',
          alt: 'Zahraa in the car lot of the dealership where she works',
          index: '02',
          caption: `<p>As a business administrator at the dealership, her days are busy.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `I had a customer come into the dealership, and the first thing that came out of the mom's mouth was, ‘Wow, you're beautiful.’ And that made me feel great. And then her son goes, ‘You have a really beautiful scarf on, as well.’ And it made me feel amazing.`,
      cite: 'Zahraa'
    },
    {
      template: 'textModule',
      text: `<p>
                But her appearance doesn’t always engender such warm feelings. Even in Los Angeles, a city known for its progressive politics, Zahraa has been the victim of hate crimes. “We’ve been called terrorists, hoodrats, we’ve been spit at . . . When my kids get to high school, I’m scared that they’re going to get beaten up in the locker room, just for being Muslim-American.”
            </p>
            <p>
                None of that can slow Zahraa—or her boys. “We’re not here to be harrassed because you want to change the country for the worse, not for the better,” she states unequivocally. She keeps her ambitious young sons focused on the bigger picture, which comes naturally to them.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-zahraa/zahraa-image-gallery2-1.jpg',
          alt: 'Zahraa and her sons at a boxing gym',
          index: '01',
          caption: `<p>Like most kids, Zahraa's sons are very active. They love to practice boxing with their mother.</p>`
        },
        {
          width: 500,
          height: 333,
          url: 'assets/images/story/story-zahraa/zahraa-image-gallery2-2.jpg',
          alt: 'Zahraa laughs with a friend, as her sons play nearby',
          index: '02',
          caption: `<p>Zahraa loves living in Los Angeles. "LA is the place to live, honestly. It has the beaches, it has the weather, it has everything."</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'My boys have big dreams. One of them wants to be an FBI agent, one of them wants to be a firefighter, and then another one wants to be a dentist. Oh, and the FBI agent also wants to own his own business.',
      cite: 'Zahraa'
    },
    {
      template: 'textModule',
      text: `<p>
                And Zahraa encourages their dreams, because, to her, there’s no better place to achieve them, no matter who you are. “We’re all here to become doctors, lawyers, to get an education, to have our own businesses, to raise our children. We’re all here to succeed. This is what America is.”
            </p>`
    },
    {
      template: 'donateModule',
      title: 'Make a donation',
      subtitle: 'And join our efforts',
      body: `<p> 
                Every issue contributing to our current immigration crisis is interconnected. Your stories inspire us to continue to take a stand — when our community of riders and drivers is threatened, we’re encouraged to take action.  
                <br><br>
                In honor of Zahraa and her family, we are humbled to support <a href="https://www.muslimadvocates.org/ways-to-give/lyft/" target="_blank">Muslim Advocates</a> — a national civil rights organization working in the courts, in the halls of power, and in communities to ensure that American Muslims may live free from hate and discrimination. 
                <br><br>
                Please join us in supporting them. 
             </p>
             `,
      cta: 'Make a donation',
      url: 'https://www.muslimadvocates.org/ways-to-give/lyft/'
    },
    {
      template: 'nextStoryModule',
      id: 'story-borderlands',
      title: 'Borderlands',
      alt: 'Two people looking at each other',
      location: 'San Diego-Tijuana Border',
      description: 'Waiting for America',
      imageSize1URL: 'assets/images/carousel/carousel-image-borderlands-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-borderlands-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/345139468.sd.mp4?s=f44835dbcf6ca40c8b273e807cd8ef65b58bb0b2&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344913411.sd.mp4?s=8a87d26b23bca91be184ae56ba716e8aca9e562e&profile_id=165'
    }
  ]
};

export const es = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>
                Video dirigido por <strong>Mohammad Gorjestani</strong>, Fotografía de <strong>Ike Edeani</strong>
            </p>`
    },
    {
      template: 'leadModule',
      body: `"Estoy criando a mis hijos para que conozcan su lado estadounidense y su lado musulmán. Aprenden su religión, juegan al fútbol, ​​aman el box. No hay ninguna diferencia entre ellos y otros niños".`
    },
    {
      template: 'textModule',
      text: `<p>
                Como cualquier madre soltera en los Estados Unidos, el horario diario de Zahraa es una especie de ballet loquísimo. Está criando a tres niños sanos, incluido a un par de gemelos, todos menores de diez años. También es musulmana, y ha descubierto que muchas personas asumen que su identidad religiosa hace que su experiencia sea diferente a la de una madre soltera que no practica su misma religión. 
            </p>
            <p>
                No lo es "Me despierto temprano todas las mañanas y, al mismo tiempo que me voy, mi vecino también sale, y ambos llevamos a nuestros hijos a la escuela, los llevamos a sus citas, hacemos exactamente los mismos mandados al mismo tiempo", dice. (Ella también se esfuerza por tener una noche de chicas con sus amigas, cuando puede).
            </p>
            <p>
                Zahraa nació en California de padres libaneses. Es estadounidense, cubre su cabeza con un pañuelo y habla sin acento. Trabaja en una concesionaria de autos cuando no está manejando con Lyft. Siendo el primer punto de contacto de muchos clientes por teléfono, nos explica, "Ellos no saben cómo me veo. Y, entonces, entran a la concesionaria y ven a una mujer musulmana con un pañuelo en la cabeza. O los sorprende para bien o para mal".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-zahraa/zahraa-image-gallery1-1.jpg',
          alt: 'Zahraa en el teléfono mientras trabajaba en una concesionaria de autos',
          index: '01',
          caption: `<p>Zahraa recibe una llamada en la concesionaria de autos donde trabaja. "Por teléfono, sueno como estadounidense, ¿sabes?"</p>`
        },
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-zahraa/zahraa-image-gallery1-2.jpg',
          alt: 'Zahraa en el lote de autos de la concesionaria donde trabaja',
          index: '02',
          caption: `<p>Como administradora de negocios en la concesionaria, sus días son ocupados.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `Tuve un cliente que vino a la concesionaria y lo primero que salió de la boca de su madre fue: 'Wow, eres hermosa'. Eso me hizo sentir muy bien. Y luego su hijo dijo: 'También tienes una bufanda realmente hermosa'. Y eso me hizo sentir increíble.`,
      cite: 'Zahraa'
    },
    {
      template: 'textModule',
      text: `<p>
                Pero su apariencia no siempre provoca sentimientos tan cálidos. Incluso en Los Ángeles, una ciudad conocida por su política progresista, Zahraa ha sido víctima de crímenes de odio. "Nos han llamado terroristas, delincuentes, nos han escupido... Cuando mis hijos lleguen a la escuela secundaria, tengo miedo de que vayan a ser golpeados en los vestidores solo por ser musulmanes-estadounidenses".
            </p>
            <p>
                Nada de esto ha frenado a Zahraa, ni a sus hijos. "No estamos aquí para que nos acosen quienes quieren hacer de este un peor lugar y no uno mejor", afirma inequívocamente. Ella hace que sus ambiciosos y jóvenes hijos se enfoquen en el panorama general, lo que les resulte natural.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-zahraa/zahraa-image-gallery2-1.jpg',
          alt: 'Zahraa y sus hijos en un gimnasio de box',
          index: '01',
          caption: `<p>Como la mayoría de los niños, los hijos de Zahraa son muy activos. Les encanta practicar el box con su madre.</p>`
        },
        {
          width: 500,
          height: 333,
          url: 'assets/images/story/story-zahraa/zahraa-image-gallery2-2.jpg',
          alt: 'Zahraa se ríe con un amigo, mientras sus hijos juegan cerca',
          index: '02',
          caption: `<p>A Zahraa le encanta vivir en Los Ángeles. "Honestamente, LA es el lugar para vivir. Tiene las playas, tiene el clima, lo tiene todo".</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'Mis hijos tienen grandes sueños. Uno de ellos quiere ser un agente del FBI, otro quiere ser bombero, y luego uno más quiere ser dentista. Ah, y el agente del FBI también quiere tener su propio negocio.',
      cite: 'Zahraa'
    },
    {
      template: 'textModule',
      text: `<p>
                Zahraa alienta sus sueños porque, para ella, no hay mejor lugar para lograrlos, no importa quién seas. "Todos estamos aquí para convertirnos en médicos, abogados, para obtener una educación, para tener nuestros propios negocios, para criar a nuestros hijos. Todos estamos aquí para ser exitosos. De esto se trata Estado Unidos".
            </p>`
    },
    {
      template: 'donateModule',
      title: 'Haz una donación',
      subtitle: 'Unete a nuestra causa',
      body: `<p> 
                Todos los problemas que contribuyen a nuestra actual crisis de inmigración están interconectados. Tus historias nos inspiran a seguir tomando una postura: cuando nuestra comunidad de viajeros y conductores sea amenazada, nosotros tomaremos las medidas pertinentes.  
                <br><br>
                En honor a Zahraa y su familia, nos sentimos honrados de apoyar a los <a href="https://www.muslimadvocates.org/ways-to-give/lyft/" target="_blank">Defensores Musulmanes (Muslim Advocates)</a>, una organización nacional de derechos civiles que trabaja en los tribunales, en los pasillos del poder y en las comunidades para garantizar que los musulmanes-estadounidenses puedan vivir libres de odio y discriminación. 
                <br><br>
                Por favor, únete a nosotros para apoyarlos. 
             </p>
             `,
      cta: 'Haz una donación',
      url: 'https://www.muslimadvocates.org/ways-to-give/lyft/'
    },
    {
      template: 'nextStoryModule',
      id: 'story-borderlands',
      title: 'Fronteras',
      alt: 'Dos personas mirandose',
      location: 'Frontera San Diego-Tijuana',
      description: 'Esperando a Estados Unidos',
      imageSize1URL: 'assets/images/carousel/carousel-image-borderlands-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-borderlands-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/345139468.sd.mp4?s=f44835dbcf6ca40c8b273e807cd8ef65b58bb0b2&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344913411.sd.mp4?s=8a87d26b23bca91be184ae56ba716e8aca9e562e&profile_id=165'
    }
  ]
};

export default {en, es};

